/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import {
  BuilderNavigationService,
  PrinterBusinessService,
  JobDetailsModel,
} from '@gh/builder-shared';
import { JobFinanceType } from '@gh/builder-shared-data';
import { NavTabBarComponent } from '@gh/common-internal-shared';
import {
  AppRouter,
  getRouteInitData,
  getRouteParentTitle,
  getRouteQueryParams,
} from '@gh/common-shared';
import { RouteDataService } from '@gh/core-data';
import { TranslationService, TranslationTuple } from '@gh/core-mls';
import {
  DialogService,
  NotificationService,
  WaitingService,
} from '@gh/core-ui';
import { isNotNil } from '@gh/core-util';
import { catchError$, skip$, switchMap$ } from '@gh/rx/operators';
import { assign } from 'lodash';
import { DrawDetailsBusinessService } from '../../resources/draw-details-business.service';
import {
  DRAW_DETAILS_INIT,
  DrawDetails,
} from '../../resources/draw-details.model';

@Component({
  standalone: false,
  selector: 'gh-draw-details',
  templateUrl: 'draw-details.component.html',
  styleUrls: ['draw-details.component.scss'],
  providers: [JobDetailsModel],
})
export class DrawDetailsComponent  implements OnInit {
  @ViewChild(NavTabBarComponent, { static: true }) navigation: NavTabBarComponent;
  parentTitle?: TranslationTuple;
  isCloud: boolean;
  isCreateMode: boolean;
  details: DrawDetails;
  queryParams: Params;

  get hasParent(): boolean {
    return isNotNil(this.parentTitle);
  }

  get title(): string {
    return this.isCreateMode ? '' : 'lbl_view_draw';
  }

  constructor(private route: ActivatedRoute,
              private translations: TranslationService,
              private router: AppRouter,
              private model: JobDetailsModel,
              private routeData: RouteDataService,
              private printerBusiness: PrinterBusinessService,
              private waitings: WaitingService,
              private dialogs: DialogService,
              private notifications: NotificationService,
              private navigations: BuilderNavigationService,
              private business: DrawDetailsBusinessService,
              public businessService: DrawDetailsBusinessService,
              ) {
  }

  get isShowESC(): boolean {
    return this.details.job.financeType === JobFinanceType.Escrow;
  }

  ngOnInit(): void {
    const { details, isCreateMode } = getRouteInitData(this.route);
    const queryParams = getRouteQueryParams(this.route);
    this.isCreateMode = isCreateMode;
    assign(this, { queryParams });
    this.parentTitle = getRouteParentTitle(this.route);
    this.details = details;

    this.isCloud = details.isCloud;

    this.route.params.pipe(
      skip$(1),
      switchMap$(({ jobId }) =>
        jobId ? this.business.getForJob(jobId).pipe(
          (this.waitings.operator()),
          catchError$((basket) => {
            this.notifications.processAll(basket);
            return [];
          })) : [DRAW_DETAILS_INIT]))
      .subscribe(
        (detailsForJob) => {
          this.isCreateMode = true;
          this.isCloud = detailsForJob.isCloud;
          this.details = detailsForJob;
        });
  }
}
